import type { StateCreator } from 'zustand'

import type { OnboardingDataSlice, OnboardingStore } from '../types'

export const createOnboardingDataSlice: StateCreator<
  OnboardingStore,
  [['zustand/immer', never]],
  [],
  OnboardingDataSlice
> = () => ({
  // Initial State
  isOnboarding: false,
  currentStep: null,
  error: null,
})
